class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector("#predictive-search");

        this.input.addEventListener(
            "input",
            this.debounce((event) => {
                this.onChange(event);
            }, 300).bind(this),
        );
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(
            `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product&resources[options][fields]=title,product_type,tag&resources[limit]=4&section_id=predictive-search`,
        )
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser()
                    .parseFromString(text, "text/html")
                    .querySelector(
                        "#shopify-section-predictive-search",
                    ).innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
                window.initialiseCartAddEvents();
                window.inititaliseButtons();
                window.addWishlistEvent();
                document.body.classList.add("no-overflow");
                var predictiveSubmit = document.getElementById("searchbutton");
                var predictiveField = document.getElementById("searchfield");
                if (predictiveSubmit) {
                    predictiveSubmit.addEventListener("click", function (e) {
                        var searchTerm = predictiveField.value;
                        var searchURL = window.Shopify.routes.root + "search/?q=" + searchTerm + "&type=product";
                        window.location = searchURL;
                        e.preventDefault();
                    });
                }
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = "block";
    }

    close() {
        this.predictiveSearchResults.style.display = "none";
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define("predictive-search", PredictiveSearch);
